<template>
  <div class="checkout-items">
    <b-card
      v-for="item in cartItems"
      :key="item.id"
      class="ecommerce-card"
      no-body
    >

      <!-- Product Image -->
      <div class="item-img">
        <b-link>
          <b-img
            src="@/assets/images/illustration/api.svg"
            alt="Imagen de materia"
          />
        </b-link>
      </div>

      <!-- Product Details: Card Body -->
      <b-card-body>
        <div class="item-name">
          <h6 class="mb-0">
            <b-link class="text-body">
              {{ item.nombre }}
            </b-link>
          </h6>
        </div>
        <small class="delivery-date text-muted">{{ item.objetivo }}</small>
      </b-card-body>

      <!-- Product Options/Actions -->
      <div class="item-options text-center">
        <div class="item-wrapper">
          <div>
            <b-badge variant="success">
              {{ item.clave }}
            </b-badge>
          </div>
          <div style="margin: 5px;">
            <b-badge variant="secondary">
              {{ item.temporalidad +' '+ item.orden }}
            </b-badge>
          </div>
          <div>
            <b-badge variant="warning">
              {{ nombreModalidad(item.modalidad) }}
            </b-badge>
          </div>
        </div>
      </div>

      <!-- <b-badge
        v-b-tooltip.hover.v-danger
        title="Quitar del carrito"
        variant="danger"
        class="removeCart-Button cursor-pointer"
        @click="removeItemFromCart(item)"
      >
        <feather-icon
          icon="XIcon"
        />
      </b-badge> -->

    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BLink, BImg, BBadge, VBTooltip,
} from 'bootstrap-vue'
import { nombreModalidad } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
// import store from '@/store'
// import { ref } from '@vue/composition-api'
// import { formatDate } from '@core/utils/filter'
// import { useEcommerce, useEcommerceUi } from '../useEcommerce'

export default {
  components: {
    BCard,
    BCardBody,
    BLink,
    BImg,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      nombreModalidad,
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.eCommerce.cartItems
    },
  },
  methods: {
    removeItemFromCart(productId) {
      this.$store.dispatch('eCommerce/removeProductFromCart', productId)
    },
  },
  // setup() {
  //   const products = ref([])

  //   const { toggleProductInWishlist } = useEcommerceUi()
  //   const { removeProductFromCart } = useEcommerce()
  //   const removeProductFromCartClick = product => {
  //     removeProductFromCart(product.id)
  //       .then(() => {
  //         const productIndex = products.value.findIndex(p => p.id === product.id)
  //         products.value.splice(productIndex, 1)

  //         store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', products.value.length)
  //       })
  //   }

  //   const fetchCartProducts = () => {
  //     store.dispatch('app-ecommerce/fetchCartProducts')
  //       .then(response => {
  //         products.value = response.data.products
  //       })
  //   }
  //   fetchCartProducts()

  //   return {
  //     products,

  //     // UI
  //     toggleProductInWishlist,
  //     removeProductFromCartClick,

  //     // Filter
  //     formatDate,
  //   }
  // },
}
</script>

<style lang="scss" scoped>
.removeCart-Button {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
